import React, { PureComponent, Fragment, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import NavbarComp from '../components/NavbarComp';
import FooterComp from '../components/FooterComp';
import { Container, Form, Row, Col, Button } from 'react-bootstrap'
import { register, pageErrors, companyDetails } from '../hooks/auth'
import PageTooltip from "../components/Tooltip"
import PinField from "react-pin-field";
import { useNavigate } from 'react-router-dom';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const mapStateToProps = (state) => {
  return {
    auth: state.auth
  }
}

const mapDispatchToProps = dispatch => ({
  register: (data, keep_login) => dispatch(register(data, keep_login)),
  pageErrors: () => dispatch(pageErrors()),
  companyDetails: (token) => dispatch(companyDetails(token))
});

const getValidate = (state) => {
  var first_name = null
  var last_name = null
  var date_of_birth = null
  var mobile = null
  var email = null
  var pin = null
  var confirm_pin = null
  var passwordEmpty = true
  var valid = true
  var terms = null
  var scroll = null

  if (state.first_name === null || state.first_name === "") {
    first_name = "Required"
    valid = false
    scroll = "first_name"
  }
  if (state.last_name === null || state.last_name === "") {
    last_name = "Required"
    valid = false
    scroll = scroll ?? "last_name"
  }
  // if(state.mobile !== null && state.mobile !== "") {
  //   if(state.mobile.length < 10 || !state.mobile.startsWith('44')) {
  //     mobile = "Not valid"
  //     valid = false
  //   }
  // }
  if (state.email === null || state.email === "") {
    email = "Required"
    valid = false
    scroll = scroll ?? "email"
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(state.email)) {
    email = "invalid email address"
    valid = false
    scroll = scroll ?? "email"
  }

  if (state.date === null || state.date === "" || state.month === null || state.month === "" || state.year === null || state.year === "" || parseInt(state.year) < 1000) {
    date_of_birth = "Required"
    valid = false
    scroll = scroll ?? "date_of_birth"
  }
  if (!/^\d{4}$/.test(state.pin)) {
    pin = "Required"
    valid = false
    passwordEmpty = false
    scroll = scroll ?? "pin"
  }

  if (!/^\d{4}$/.test(state.confirm_pin)) {
    confirm_pin = "Required"
    valid = false
    passwordEmpty = false
    scroll = scroll ?? "confirm_pin"
  }

  const disallowedPins = ["0000", "1111", "2222", "3333", "4444", "5555", "6666", "7777", "8888", "9999", "1234", "4321"];
  if (disallowedPins.includes(state.pin)) {
    pin = "This PIN is too easy to guess. Please choose another."
    valid = false
    passwordEmpty = false
    scroll = scroll ?? "pin"
  }
  if (passwordEmpty && state.pin !== state.confirm_pin) {
    confirm_pin = "PIN number do not match"
    valid = false
    scroll = scroll ?? "confirm_pin"
  }
  if (!state.terms) {
    terms = "Required"
    valid = false
  }

  return { data: { first_name, last_name, email, mobile, date_of_birth, pin, confirm_pin, terms }, valid, scroll }
}

const NavigateOnStateChange = ({ shouldNavigate, to }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (shouldNavigate) {
      navigate(to);
    }
  }, [shouldNavigate, navigate, to]);

  return null;
};

class Register extends PureComponent {

  constructor(props) {
    super(props);
    this.myDivRef = createRef()
    this.inputsRef = [createRef(), createRef(), createRef()];
    this.PinFieldRef = [createRef(), createRef()];
    this.state = {
      first_name: null,
      last_name: null,
      email: null,
      mobile: null,
      date: null,
      month: null,
      year: null,
      pin: null,
      confirm_pin: null,
      error: {
        first_name: null,
        last_name: null,
        email: null,
        mobile: null,
        date_of_birth: null,
        pin: null,
        confirm_pin: null,
        terms: null
      },
      terms: false,
      keep_loged: false,
      mailPhonetaken: false,
      scroll: null,
      shouldNavigate: false,
      token: null,
      companyDetails: false,
      type: null,
      country_code: "+44"
    };
  }
  componentDidMount() {
    const path = window.location.pathname;
    const pathParts = path.split('/');
    const token = pathParts[1];
    this.setState({ token })
  }

  componentDidUpdate() {
    var state = this.state
    if (this.props.auth.error_page === "register") {
      this.props.pageErrors()
      this.errorUpdate(this.props.auth.errors)
    }
    if (!state.mailPhonetaken && (state.error.email == "The email has already been taken." || state.error.email == "The mobile has already been taken.")) {
      this.setState({ mailPhonetaken: true })
    }

    if (this.props.auth.register !== null && this.props.auth.access_token !== null) {
      setTimeout(() => {
        this.setState({ shouldNavigate: true });
      }, 1000)
    }
    if ((this.props.auth.company == null && !this.state.companyDetails) || (this.state.type == null && !this.state.companyDetails)) {
      this.props.companyDetails(this.state.token)
      this.setState({
        companyDetails: true,
        type: this.props.auth.company !== null ? this.props.auth.company.type : null
      }, () => {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          this.setState({
            companyDetails: false
          })
        }, 10000)
      })
    }
  }

  errorUpdate = (errors) => {
    this.setState({
      error: {
        ...this.state.error,
        first_name: errors.first_name !== undefined ? errors.first_name[0] : null,
        last_name: errors.last_name !== undefined ? errors.last_name[0] : null,
        email: errors.email !== undefined ? errors.email[0] : null,
        mobile: errors.mobile !== undefined ? errors.mobile[0] : null,
        date_of_birth: errors.date_of_birth !== undefined ? errors.date_of_birth[0] : null,
        pin: errors.first_name !== undefined ? errors.pin[0] : null,
        confirm_pin: errors.confirm_pin !== undefined ? errors.confirm_pin[0] : null
      }

    })
  }

  handleChange = (e) => {
    if (e.target.name == "email" || e.target.name == "mobile") {
      this.setState({ mailPhonetaken: false })
    }
    this.setState({
      [e.target.name]: e.target.value,
      error: {
        ...this.state.error,
        [e.target.name]: null
      }
    })
  }

  changeDateField = (e, index) => {
    var name = e.target.name
    var value = e.target.value
    if (parseInt(value) > e.target.max) {
      return false
    }

    if (value.length === 2 && index !== 2) {
      this.inputsRef[index + 1].current.focus();
    }

    this.setState({
      [name]: value,
      error: {
        ...this.state.error,
        'date_of_birth': null
      }
    })
  }

  handleScrollToDiv = () => {
    if (this.myDivRef.current) {
      const divPosition = this.myDivRef.current.getBoundingClientRect().top;
      const offsetPosition = divPosition + window.pageYOffset - 100;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  }

  handleRegister = () => {
    if (getValidate(this.state).valid && this.state.terms) {
      this.props.register({
        first_name: this.state.first_name,
        last_name: this.state.last_name,
        email: this.state.email,
        country_code: this.state.country_code,
        mobile: this.state.mobile,
        date_of_birth: this.state.year + "-" + this.state.month.toString().padStart(2, '0') + "-" + this.state.date.toString().padStart(2, '0'),
        pin: this.state.pin,
        confirm_pin: this.state.confirm_pin,
        url_token: window.location.pathname.split('/')[1]
      }, this.state.keep_loged)
    } else if (!getValidate(this.state).valid) {
      this.setState({
        error: getValidate(this.state).data,
        scroll: getValidate(this.state).scroll
      }, () => this.handleScrollToDiv())
    }
  }

  handlePinvalue = (value, name) => {
    this.setState({
      [name]: value,
      error: {
        ...this.state.error,
        [name]: null
      }
    })
  }

  handleChecked = (e) => {
    this.setState({ [e.target.name]: e.target.checked })
    if (e.target.name === "terms") {
      this.setState({
        error: {
          ...this.state.error,
          [e.target.name]: null
        }
      })
    }
  }

  handleBackspace = (event, index) => {
    if (event.key === "Backspace" && !event.target.value && index > 0) {
      this.inputsRef[index - 1].current.focus();
    }

    if (
      [46, 8, 9, 27, 13, 110, 190].includes(event.keyCode) ||
      (event.keyCode === 65 && event.ctrlKey === true) ||
      (event.keyCode === 67 && event.ctrlKey === true) ||
      (event.keyCode === 86 && event.ctrlKey === true) ||
      (event.keyCode === 88 && event.ctrlKey === true) ||
      (event.keyCode >= 35 && event.keyCode <= 39)
    ) {
      return;
    }

    if (
      (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) &&
      (event.keyCode < 96 || event.keyCode > 105)
    ) {
      event.preventDefault();
    }
  };

  customizeInputs = (inputElements) => {
    if (inputElements) {
      inputElements.forEach((input) => {
        if (input && !input.placeholder) {
          input.placeholder = "*";
          input.type = "password";
          input.inputMode = "numeric";
        }
      });
    }
  }

  handleClearBackspace = (value, pinIndex) => {
    if (value === "" && this.PinFieldRef[pinIndex].current[0]) {
      this.PinFieldRef[pinIndex].current[3].focus();
    }
  }

  handleKeyDown = (event) => {
    if (
      [46, 8, 9, 27, 13, 110, 190].includes(event.keyCode) ||
      (event.keyCode === 65 && event.ctrlKey === true) ||
      (event.keyCode === 67 && event.ctrlKey === true) ||
      (event.keyCode === 86 && event.ctrlKey === true) ||
      (event.keyCode === 88 && event.ctrlKey === true) ||
      (event.keyCode >= 35 && event.keyCode <= 39)
    ) {
      return;
    }

    if (
      (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) &&
      (event.keyCode < 96 || event.keyCode > 105)
    ) {
      event.preventDefault();
    }
  }

  handlePaste = (event) => {
    const pastedData = event.clipboardData.getData('text');
    if (!/^\d+$/.test(pastedData)) {
      event.preventDefault()
    }
  };
  handlePasteStop = (event) => {
    event.preventDefault()
  };

  handlePhoneChange = (value, countryData) => {
    const newCountryCode = `+${countryData.dialCode}`; 
      this.setState({
        country_code: newCountryCode,
        mobile: ""
      })
  };


  render() {
    console.log(this.state.country_code)
    return <Fragment>

      <NavbarComp />

      {/* Register page sections */}
      <div className="page-sections">
        <div className='register-wrap'>
          <Container>
            <div className='register-contents'>
              <h2 className='main-title-style'>REGISTRATION</h2>
              <p>Welcome to <span>MyAlertness App in cooperation with {this.props.auth.company !== null ? this.props.auth.company.name : ""}</span> At the beginning of each shift, you undertake an alertness test. We then show you your score and how it compares to your rolling baseline score so you get an objective view of your alertness when starting your shift.</p>
              <p>If you get objective feedback on your alertness, we hope you will make adjustments during the working day and be more mindful of the effects of tiredness and fatigue on low-alertness days – thereby keeping you safer.</p>
              <p>We will show you how you perform against your baseline each shift and hopefully help you better understand what factors affect your alertness. We inform your employer of your score each shift. On days that you are below baseline, your employer will run additional fatigue protocols to ensure your safety. You can read our <a href="/terms-and-conditions/1" target="_blank" rel="nofollow">Privacy Policy</a> to see how your data will be used.</p>
              <p>Please start by setting up your login details.</p>
              <div className='register-form'>
                <Row>
                  <Col lg={6} md={12} ref={this.state.scroll === "first_name" ? this.myDivRef : null}>
                    <Form.Group className="mb-4" controlId="formGroupFName">
                      <Form.Label>First name*{this.state.error.first_name !== null ? <span className="error-span">{this.state.error.first_name}</span> : null}</Form.Label>
                      <Form.Control onChange={this.handleChange} value={this.state.first_name} name="first_name" type="text" placeholder="Enter first name" />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={12} ref={this.state.scroll === "last_name" ? this.myDivRef : null}>
                    <Form.Group className="mb-4" controlId="formGroupLName">
                      <Form.Label>Last name*{this.state.error.last_name !== null ? <span className="error-span">{this.state.error.last_name}</span> : null}</Form.Label>
                      <Form.Control onChange={this.handleChange} value={this.state.last_name} name="last_name" type="text" placeholder="Enter last name" />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={12} ref={this.state.scroll === "email" ? this.myDivRef : null}>
                    <Form.Group className="mb-4" controlId="formGroupEmail">
                      <PageTooltip
                        title="Email"
                        text="Adding an email address enables you to set reminders to complete tests at the beginning of your shift. Adding an email also makes it easier to reset your PIN if you forget it."
                        error={this.state.error.email !== null}
                        error_text={this.state.error.email}
                      />
                      <Form.Control onChange={this.handleChange} value={this.state.email} name="email" type="email" placeholder="Enter email address" />
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={12} >
                    <Form.Group className="mb-4" controlId="formGroupPhone">
                      <div className='register-mobile'>
                        <PageTooltip
                          title="Mobile phone"
                          text="Adding a mobile phone number enables you to set reminders to complete tests at the beginning of your shift."
                          error={this.state.error.mobile !== null}
                          error_text={this.state.error.mobile}
                        />
                      </div>
                      <div className='mobile-div'>
                        <PhoneInput
                          className="country-code-mobile"
                          country={"gb"}
                          value={this.state.country_code}
                          onChange={this.handlePhoneChange}
                          disableCountryCode={false}
                          disableDropdown={false}
                          enableAreaCodes={false}
                          inputProps={{
                            readOnly: true
                          }}
                        />
                        <Form.Control className='mobile-value' onPaste={this.handlePaste} onKeyDown={this.handleKeyDown} onChange={this.handleChange} value={this.state.mobile} name="mobile" type="number" inputmode="numeric" pattern="[0-9]*" placeholder="Enter mobile phone number starting with 0" />

                      </div>
                      {/* <span>Your country code should be included, example 44xxxxxxxxxxxxx</span> */}
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={12} ref={this.state.scroll === "date_of_birth" ? this.myDivRef : null}>
                    <Form.Group className="mb-4" controlId="formGroupDOB">
                      <Form.Label>Date of birth*{this.state.error.date_of_birth !== null ? <span className="error-span">{this.state.error.date_of_birth}</span> : null}</Form.Label>
                      <div className='dob-field'>
                        <Form.Control
                          type="number"
                          value={this.state.date}
                          onChange={(e) => this.changeDateField(e, 0)}
                          onKeyDown={(e) => this.handleBackspace(e, 0)}
                          onPaste={this.handlePasteStop}
                          ref={this.inputsRef[0]}
                          inputMode="numeric"
                          name="date" placeholder="DD" max="31" /> &nbsp;–&nbsp;
                        <Form.Control
                          type="number"
                          value={this.state.month}
                          onChange={(e) => this.changeDateField(e, 1)}
                          onKeyDown={(e) => this.handleBackspace(e, 1)}
                          onPaste={this.handlePasteStop}
                          inputMode="numeric"
                          ref={this.inputsRef[1]}
                          name="month" placeholder="MM" max="12" /> &nbsp;–&nbsp;
                        <Form.Control
                          className='dob-year-field'
                          type="number"
                          value={this.state.year}
                          onChange={(e) => this.changeDateField(e, 2)}
                          onKeyDown={(e) => this.handleBackspace(e, 2)}
                          onPaste={this.handlePasteStop}
                          ref={this.inputsRef[2]}
                          inputMode="numeric"
                          name="year" placeholder="YYYY" max="9999" />
                      </div>
                      <span>If you were born on the 13th July 1980 you would enter 13 – 07 – 1980.</span>
                    </Form.Group>
                  </Col>
                  <Col lg={6} md={12}></Col>
                  <Col lg={12} md={12} ref={this.state.scroll === "pin" ? this.myDivRef : null}>
                    <Form.Group className="mb-4" controlId="formGroupPin">
                      <PageTooltip
                        title="Login PIN number"
                        text="Please now enter a 4-digit PIN, so we can make sure your login details are unique but also quick and easy to use every day. You cannot enter consecutive numbers such as 0000 or 5555 along with other easy-to-guess numbers like 1234."
                        error={this.state.error.pin !== null}
                        error_text={this.state.error.pin}
                      />
                      <div className="pin-wrapper">
                        <span className='pin-class-dash-1'></span>
                        <span className='pin-class-dash-2'></span>
                        <PinField
                          autoComplete="new-password"
                          onChange={(value) => this.handlePinvalue(value, "pin")}
                          length={4}
                          validate={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}
                          filter={/^\d$/}
                          onComplete={() => {
                            if (this.PinFieldRef[1].current && this.PinFieldRef[1].current[0]) {
                              this.PinFieldRef[1].current[0].focus();
                            }
                          }}
                          ref={(inputElements) => {
                            this.PinFieldRef[0].current = inputElements;
                            this.customizeInputs(inputElements);
                          }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col lg={12} md={12} ref={this.state.scroll === "confirm_pin" ? this.myDivRef : null}>
                    <Form.Group className="mb-4" controlId="formGroupConfirmPin">
                      <Form.Label>Confirm PIN number {this.state.error.confirm_pin !== null ? <span className="error-span">* {this.state.error.confirm_pin}</span> : null}</Form.Label>
                      <div className="pin-wrapper">
                        <span className='pin-class-dash-1'></span>
                        <span className='pin-class-dash-2'></span>
                        <PinField
                          autoComplete="confirm-password"
                          validate={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"]}
                          length={4}
                          onChange={(value) => {
                            this.handlePinvalue(value, "confirm_pin")
                            this.handleClearBackspace(value, 0);
                          }}
                          ref={(inputElements) => {
                            this.PinFieldRef[1].current = inputElements;
                            this.customizeInputs(inputElements);
                          }}
                        />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col lg={12}>
                    <div className='register-consent'>
                      <h4>CONSENT</h4>
                      <div key={`default-checkbox`} className="form-checkboxes">
                        <Form.Check type="checkbox" id={`keep-login`} onClick={this.handleChecked} checked={this.state.keep_loged} name='keep_loged' label={`Keep me logged in for 60 days`} />
                        <h3>Privacy Statement for Individual Consent</h3>
                        <p>I understand that all personal data and research related data is held and processed in the strictest confidence, and in accordance with GDPR. I agree that I will not seek to restrict the use of the results of the study on the understanding that my anonymity is preserved.</p>
                        <h3>Anonymising Data</h3>
                        {this.state.type == "identified" ? <Fragment>
                          <p>The data generated from the project will be quantitative and qualitative in nature, encompassing electronic format data. Data collection and storage will be in accordance with the principles of Good Clinical Practice. All data will be maintained in a database. This database will be accessible to researchers involved in the study and staff at your organisation with a username and password securely. All data, analysed for research will be anonymised, with a unique identity code, ensuring that no personal data is attributable to a participant in the research. The data controller will be able to access identifiable information, which is necessary to identify and sometimes communicate with individuals. All electronic data will be stored and curated in accordance with industry-leading standards and protocols. Named individuals at your organisation will be able to see individual alertness test results and whether your result is above, below or in line with your baseline score for each day of participation. This is primarily so they can apply additional safety protocols where users meet the organisation’s threshold for follow up. Ultimately, we hope this will help keep you safer at work.</p>
                        </Fragment> : null}
                        {this.state.type == "anonymous" ? <Fragment>
                          <p>The data generated from the project will be quantitative and qualitative in nature, encompassing electronic format data. Data collection and storage will be in accordance with the principles of Good Clinical Practice. All data will be maintained in a database, only accessible to researchers involved in the study and staff with a username and password securely. All data, analysed for research will be anonymised, with a unique identity code, ensuring that no personal data is attributable to a participant in the research. The data controller will be able to access identifiable information, which is necessary to identify and sometimes communicate with individuals. All electronic data will be stored and curated in accordance with industry-leading standards and protocols. </p>
                        </Fragment> : null}


                        <a href={this.state.type == "identified" ? "/terms-and-conditions/1" : "/terms-and-conditions/0"} target="_blank" rel="noopener noreferrer">Find out more about our privacy policy and our terms and conditions – see below</a>
                        <Form.Check type="checkbox" id={`data-study`} onClick={this.handleChecked} checked={this.state.terms} name='terms'
                          label={
                            <>
                              I agree
                              {this.state.error.terms !== null ? <span className="error-span">* Required</span> : null}
                            </>
                          }
                        />
                      </div>
                    </div>
                  </Col>
                  <Col lg={12}>
                    <div className='form-submit-btn'>
                      <Button onClick={this.handleRegister}>Register</Button>
                    </div>
                  </Col>

                  <Col className="register-exist-error">
                    {this.state.mailPhonetaken ? <span className="error-span">
                      This email / phone number is already listed on our system. Please use visit <a href="/login" rel="nofollow">www.myalertness.com/login</a> and use the details you registered with us previously. You can also reset your PIN if you have forgotten it or contact us from that page too.
                    </span> : null}
                  </Col>
                </Row>
              </div>
            </div>
          </Container>
        </div>
      </div>
      {/* End of Register page sections */}
      <NavigateOnStateChange shouldNavigate={this.state.shouldNavigate} to={"/" + this.state.token + "/register-confirm"} />
      <FooterComp />

    </Fragment>
  }
}

Register.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Register);